/** The last page a list of `totalCount` items split into pages of `pageSize` has; never below one,
 * so an empty list still has a page to show. */
export const lastPageOf = (totalCount: number, pageSize: number) =>
    Math.max(1, Math.ceil(totalCount / pageSize));

export const pageToFlatArray = <T>(pages: T[][]): T[] => {
    return pages.flat();
};

export const flattenPaginatedData = <T>(
    paginatedData: { pages: Array<{ items: T[] }> } | Array<{ items: T[] }> | undefined,
): T[] => {
    if (!paginatedData) {
        return [];
    }

    if ('pages' in paginatedData) {
        return paginatedData.pages.flatMap((page) => page.items);
    }

    return paginatedData.flatMap((page) => page.items);
};
